<template>
  <v-form
      ref="modifyJobDescForm"
      @submit.prevent=""
      class="fill-height of-y"
      :disabled="loading"
  >
    <div class="of-y">
      <div class="d-flex align-center primary pl-3 pr-2">
        <div class="flex-grow-1 sub--text">
          {{jobDescription.id ? 'Edit Job Description' : 'Create Job Description'}}
        </div>
        <div v-if="!jobDescription.id">
          <v-btn
              icon
              color="white"
              small
              @click="$emit('dismiss')"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="pb-1">
        <div class="flex-grow-1 of-y px-2 pb-1">
          <v-text-field
              label="Description"
              hide-details="auto"
              v-model="jobDescription.description"
              @input="changesMade = true"
              :rules="[validationRules.required, validationRules.notNull, duplicateDescription]"
          />
        </div>
        <div class="text-right pr-2 pb-1 pt-2">
          <v-btn
              @click="validateSave()"
              fab
              small
              color="secondary"
              :loading="loading"
              :disabled="!changesMade || loading"
          >
            <v-icon v-if="!loading">mdi-content-save</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </v-form>
</template>

<script>
import {mapGetters} from 'vuex'
import {validationRules} from "@/core/codeFunctions";

export default {
  props: {
    editJobDescription: Object
  },
  data() {
    return {
      loading: false,
      validationRules: validationRules,
      changesMade: false,
      jobDescription: {id: null, description: null},
    }
  },
  watch: {
    editJobDescription: {
      deep: true,
      immediate: true,
      handler(val) {
        this.changesMade = false
        this.jobDescription = JSON.parse(JSON.stringify(val || {id: null, description: null}))
      }
    },
  },
  methods: {
    duplicateDescription(val) {
      if (!val) return "A description is required"
      if (this.jobDescriptions.find(jd => jd.id !== this.jobDescription.id && (this.jobDescription.description || '').toLowerCase() === (jd.description || '').toLowerCase())) {
        return "Duplicate job description"
      }
      return true
    },
    async validateSave() {
      if (!this.$refs.modifyJobDescForm.validate()) return false
      this.$emit('save', {jobDescription: this.jobDescription, ref: this})
    }
  },
  computed: {
    ...mapGetters(['jobDescriptions'])
  },
}
</script>
